<template>
  <div>
    <b-row>
      <b-col lg="6" sm="6">
        <b-link :to="{ name: 'register-patient' }">
          <statistic-card-horizontal
            icon=""
            :statistic="$t('reception.add-patient')"
            class="modify"
          />
        </b-link>
      </b-col>
      <b-col lg="6" sm="6">
        <b-link :to="{ name: 'Reception-Lobby' }">
          <statistic-card-horizontal
            icon=""
            :statistic="$t('reception.lobby')"
            class="modify"
          />
        </b-link>
      </b-col>
    </b-row>

    <!-- <Printables /> -->

    <ReceptionSearch />
  </div>
</template>
<script>
import { BCard, BRow, BCol, BLink } from 'bootstrap-vue';
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue';
import ReceptionSearch from './ReceptionSearch.vue';
import Printables from './Printables';

export default {
  components: {
    ReceptionSearch,
    BCard,
    BRow,
    BCol,
    BLink,
    StatisticCardHorizontal,
    Printables,
  },
};
</script>
<style scoped>
.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>
